<div class="modal-content">
  <div class="text-right">
    <mat-icon (click)="onSubmit(false)" style="cursor: pointer">close</mat-icon>
  </div>
  <br />
  <div class="content">
    <form>
      <div class="note-message">
        <strong>Note:</strong> Add the New Client Name
      </div>

      <div class="form-group d-flex align-items-center">
        <label class="col-md-3">Client Name:</label>
        <input
          type="text"
          class="form-control col-md-9"
          [(ngModel)]="client_name"
          name="client_name"
          autocomplete="off"
        />
      </div>
      <br />
      <button
        type="button"
        class="btn btn-light hover-clear clear"
        (click)="onSubmit(true)"
      >
        <span>Submit</span>
      </button>
    </form>
  </div>
</div>
